<template>
  <div
    class="print-only"
  >
    <h2 class="mtn black bg-ghost-gray pas">
      Footnotes
    </h2>
    <div
      v-for="(footnote, index) of footnotes"
      :key="index"
      class="footnote grid-x mbm"
    >
      <div
        class="medium-2"
        v-html="footnote.section"
      />
      <div
        class="medium-22"
        v-html="philaLink(footnote.copy)"
      />
    </div>
  </div>
</template>


<script>
export default {
  name: 'PrintFootnotes',
  props: {
    footnotes: {
      type: Array,
      required: true,
    },
  },
};
</script>


